import { Button } from "risa-oasis-ui_v2";

interface FirstStpBucketingFooterProps {
  dirtyCount: number;
  saving: boolean;
  onSave: () => void;
}

const FirstStpBucketingFooter = ({
  dirtyCount,
  saving,
  onSave,
}: FirstStpBucketingFooterProps) => {
  return (
    <div className="flex flex-shrink-0 items-center justify-end gap-2 border-t border-primaryGray-16 px-6 py-3">
      <Button
        buttonType="primary"
        size="medium"
        disabled={dirtyCount === 0 || saving}
        onClick={onSave}
      >
        {saving ? "Saving…" : "Save Changes"}
      </Button>
    </div>
  );
};

export default FirstStpBucketingFooter;
